import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-12 mb-5" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-12  mb-5" }, null, -1)
const _hoisted_3 = { class: "col-xxl-12" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Retail Sales")
  ])
], -1)
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_8 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "#"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Customer Name"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "Date"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Product Name"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Quantity"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Income")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_3, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card"]
      }, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("table", _hoisted_7, [
              _hoisted_8,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", null, "   " + _toDisplayString(item.id), 1),
                    _createVNode("td", null, _toDisplayString(item.custname), 1),
                    _createVNode("td", null, _toDisplayString(item.terminal_date), 1),
                    _createVNode("td", null, _toDisplayString(item.prodname), 1),
                    _createVNode("td", null, _toDisplayString(item.qty), 1),
                    _createVNode("td", null, _toDisplayString(item.income), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}